import { render, staticRenderFns } from "./page500.vue?vue&type=template&id=5f66fe1e&scoped=true"
import script from "./page500.vue?vue&type=script&lang=js"
export * from "./page500.vue?vue&type=script&lang=js"
import style0 from "./page500.vue?vue&type=style&index=0&id=5f66fe1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f66fe1e",
  null
  
)

export default component.exports